export default __webpack_public_path__ + "static/media/note.f149bddf.svg";